import resolveColor from "@insite/mobius/utilities/resolveColor";
import { BlockBaseProps } from "@tKgpco/Components/Common/Block/Block";
import { BlockVariantBaseProps } from "@tKgpco/Components/Common/Block/variant/base";
import { clearfixStyles } from "@tKgpco/theme/mixins";
import { css } from "styled-components";

export interface BlockVariantAlternativeBaseProps {
    backgroundColor?: string;
}
export interface BlockVariantAlternativeProps extends BlockVariantBaseProps, BlockVariantAlternativeBaseProps {}

const defaultProps: BlockVariantAlternativeProps = {
    backgroundColor: "common.accent",
};

const staticProps: BlockVariantBaseProps = {
    containerCss: css<BlockBaseProps>`
        ${clearfixStyles()}

        ${({ theme, variantProps }) => {
            const backgroundColor = variantProps?.alternative?.backgroundColor;

            return css`
                ${backgroundColor ? `background-color: ${resolveColor(backgroundColor, theme)};` : ""}
            `;
        }}
    `,
};

export default { defaultProps, staticProps };
